import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {UrlService} from "../url.service";

@Injectable()
export class AssessmentsGroupService {
    private BASE_URL: string;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/assessmentsGroups';
    }

    loadAssessmentGroup(assessmentGroupId, languageCode) {
        let params = new HttpParams();
        if (languageCode) {
            params = params.set('languageCode', languageCode);
        }

        const requestOptions = {
            params: params
        }

        return this.http.get(this.BASE_URL + '/' + assessmentGroupId, requestOptions);
    }

    loadAssessmentGroupInfo(assessmentGroupId) {
        return this.http.get(this.BASE_URL + '/' + assessmentGroupId + '/info');
    }

    createAssessmentGroup(instrumentType, clientId, languageCode): any {
        let params = new HttpParams();

        if (languageCode) {
            params = params.set('languageCode', languageCode);
        }

        const requestOptions = {
            params: params
        }

        return this.http.get(this.BASE_URL + '/create/' + instrumentType + '/' + clientId, requestOptions);
    }

    saveAssessmentGroup(assessmentGroup, languageCode): any {
        let params = new HttpParams();

        if (languageCode) {
            params = params.set('languageCode', languageCode);
        }

        const requestOptions = {
            params: params
        }

        return this.http.put(`${this.BASE_URL}/${assessmentGroup.id}`, assessmentGroup, requestOptions);
    }

    submitAssessmentGroup(assessmentGroup) {
        return this.http.put(this.BASE_URL + '/' + assessmentGroup.id + '/submit', assessmentGroup);
    }

    recallAssessmentGroup(assessmentGroup) {
        return this.http.put(this.BASE_URL + '/' + assessmentGroup.id + '/recall', assessmentGroup);
    }

    submitAndApproveAssessmentGroup(assessmentGroup) {
        return this.http.put(this.BASE_URL + '/' + assessmentGroup.id + '/submitAndApprove', assessmentGroup);
    }

    submitAndApproveAssessmentGroupById(groupId) {
        return this.http.put(this.BASE_URL + '/' + groupId + '/submitAndApprove', {});
    }

    rejectAssessmentGroup(assessmentGroup, rejectNote) {
        let params = new HttpParams();

        if (rejectNote) {
            params = params.set('rejectNote', rejectNote);
        }

        const requestOptions = {
            params: params
        }

        return this.http.put(this.BASE_URL + '/' + assessmentGroup.id + '/reject', assessmentGroup, requestOptions);
    }

    rejectAssessmentGroupById(groupId, rejectNote) {
        let params = new HttpParams();

        if (rejectNote) {
            params = params.set('rejectNote', rejectNote);
        }

        const requestOptions = {
            params: params
        }

        return this.http.put(this.BASE_URL + '/' + groupId + '/reject', {}, requestOptions);
    }

    deleteAssessmentGroup(assessmentGroup) {
        return this.http.delete(this.BASE_URL + '/' + assessmentGroup.id);
    }

    getLastAssessmentToDate(clientId, ouId, baseInstrumentTypes) {
        let params = new HttpParams();
        params = params.set('clientId', clientId);
        params = params.set('ouId', ouId);
        baseInstrumentTypes.forEach(t => params = params.append('baseInstrumentTypes', t));

        const requestOptions = {
            params: params
        }

        return this.http.get(this.BASE_URL + '/lastAssessment', requestOptions);
    }

    getGroupSurroundingIds(clientId, ouId, instrumentBaseType, instrumentType, assessmentDate, reasonForAssessment, assessmentGroupId) {
        let params = new HttpParams();
        params = params.set('clientId', clientId);
        params = params.set('ouId', ouId);
        params = params.set('instrumentBaseType', instrumentBaseType);
        params = params.set('instrumentType', instrumentType);
        params = params.set('assessmentDate', assessmentDate);
        params = params.set('reasonForAssessment', reasonForAssessment);
        params = params.set('assessmentGroupId', assessmentGroupId);

        const requestOptions = {
            params: params
        }

        return this.http.get(this.BASE_URL + '/surroundingIds', requestOptions);
    }

    getAlgorithmScoresForAssessmentGroup(groupId) {
        return this.http.get(this.BASE_URL + '/' + groupId + '/algorithmsresults');
    }

    makeRelation(baseAssessmentId, relatedAssessmentId) {
        return this.http.put(this.BASE_URL + '/makeRelation/' + baseAssessmentId + '/' + relatedAssessmentId, {});
    }
}
